/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
 */
export interface ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount {
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
     */
    critical?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
     */
    high?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
     */
    medium?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
     */
    low?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
     */
    info?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount
     */
    count?: number;
}

/**
 * Check if a given object implements the ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount interface.
 */
export function instanceOfControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSON(json: any): ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount {
    return ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSONTyped(json, false);
}

export function ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'critical': !exists(json, 'critical') ? undefined : json['critical'],
        'high': !exists(json, 'high') ? undefined : json['high'],
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'low': !exists(json, 'low') ? undefined : json['low'],
        'info': !exists(json, 'info') ? undefined : json['info'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCountToJSON(value?: ControlAppSchemasExternalAsmEntityResponsesEntityVulnerabilitiesCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'critical': value.critical,
        'high': value.high,
        'medium': value.medium,
        'low': value.low,
        'info': value.info,
        'count': value.count,
    };
}

